import styled, { css } from 'styled-components';
import { themeStyles } from '../../../styles/theme';

import TimesWhiteIcon from '../../../images/icon_times_white.svg';

export const StyledMessage = styled.div`
  text-align: center;
  padding: 2rem 0;
`;

export const StyledDrawerWrapper = styled.div`
  z-index: 99999; // Needs to be higher than navbar
  position: relative;
`;

export const customHeaderStyles = css`
  background: ${themeStyles.colors.black.main};
  color: ${themeStyles.colors.white.main};

  button {
    background-image: url('${TimesWhiteIcon}');
    top: 50%;
    right: 18px;
  }
`;